import { LucideImage } from "lucide-react";
import React, { useState } from "react";

const FGIndustryCard = ({
  selectedIndustry,
  setSelectedIndustry,
  industry,
}) => {
  const [loaded, setLoaded] = useState(false);

  if (!industry?.industryLogoUrl) {
    return <LucideImage size={17} />;
  }
  return (
    <div
      className={`${
        selectedIndustry?.industryId === industry.industryId
          ? "border-[#FEC84B] bg-[#FFFAEB] text-[#0F1B23] font-medium"
          : "border-gray-300 text-[#344054] font-medium "
      } flex gap-[.6rem] items-center border cursor-pointer 
            shadow-sm hover:border-[#FEC84B] transition-all duration-200 text-[.88rem] rounded-lg px-[.6rem] py-[.48rem]`}
      onClick={() => setSelectedIndustry(industry)}
    >
      <div className="border border-gray-300 bg-white rounded-[6px] flex justify-center items-center px-[.2rem] py-[.3rem] w-[32px]">
        {!loaded && <LucideImage size={17} />}
        <img
          src={industry.industryLogoUrl}
          width={17}
          alt="icon"
          style={{ display: loaded ? "inline" : "none" }}
          onLoad={() => setLoaded(true)}
          onError={() => setLoaded(false)}
        />
      </div>{" "}
      <div className="break-all hyphens-auto">{industry.industryTitle}</div>
    </div>
  );
};

export default FGIndustryCard;
